import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown } from "react-icons/fi";
import { IoClose } from "react-icons/io5";


export interface DropdownOption {
    label: string;
    value: string | number;
    taskId?: string;
    participant?: string;
    friendlyId? : number
}

const ChevronDown = FiChevronDown as any;
const X = IoClose as any;

interface SelectDropdownProps {
    label?: string;
    name: string;
    value: string | number;
    onChange: (value: string | number) => void;
    options: DropdownOption[];
    error?: string;
    icon?: string;
    isSearchable?: boolean;
    borderBotttom?: boolean;
    disabled?: boolean;
    loadingTasks?: boolean;
}

const TaskDropdown: React.FC<SelectDropdownProps> = ({
    label,
    name,
    value,
    onChange,
    options,
    error,
    icon,
    isSearchable = true,
    borderBotttom,
    disabled = false,
    loadingTasks
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

    const dropdownRef = useRef<HTMLDivElement>(null);
    const inputRef = useRef<HTMLInputElement>(null);

    const filteredOptions = options.filter(o =>
        (o.friendlyId && o.friendlyId.toString().includes(searchTerm)) ||
        o.label.toLowerCase().includes(searchTerm.toLowerCase()) 
    );

    const handleClear = (e: React.MouseEvent) => {
        e.stopPropagation(); // prevent dropdown open
        if (disabled) return;
        onChange("");        // or 0 if you prefer
        setSearchTerm("");
    };

    console.log("Tasks options : ",options);
    
    console.log("Tasks value : ",value);
    


    // Close dropdown when clicking outside
    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);

    // Auto focus input
    useEffect(() => {
        if (isOpen && isSearchable && inputRef.current) {
            inputRef.current.focus();
        }
    }, [isOpen, isSearchable]);

    const selectedLabel =
        options.find(o => o.value === value)?.label || "Select";

    return (
        <div className="w-full" ref={dropdownRef}>

            {/* {label && <label className="custom_label">{label}</label>} */}

            <div className="relative">
                <div
                    className={`
                    h-[48px] border-x-[1px] border-[#F5F6F7] ps-3 flex items-center 
                    focus:outline-none focus:ring-0
                    ${borderBotttom ? "border-y-2" : "border-t-2"}
                    ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}
                `}
                    onClick={() => !disabled && setIsOpen(!isOpen)}
                    tabIndex={disabled ? -1 : 0} // Needed for keyboard but we remove outline
                    style={{ outline: "none" }}
                >
                    {/* Left Icon */}
                    {icon && (
                        <img
                            src={icon}
                            alt="icon"
                            className="absolute left-3 w-[25px] h-[25px] pointer-events-none"
                        />
                    )}
                    {/* {isOpen && isSearchable ? (
                        <input
                            ref={inputRef}
                            className={`w-full bg-transparent outline-none border-none text-[13px] 2xl:text-[16px] text-[#747474] 
                            ${icon ? "ps-10" : "ps-2"} !py-0`}
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            style={{
                                border: 'none',
                                background: 'transparent',
                                outline: 'none',
                                boxShadow: 'none',
                                color: '#747474',
                            }}
                        />
                    ) : (
                    )} */}
                    {loadingTasks ? (
                        <p className={`m-0 text-[13px] 2xl:text-[16px] text-[#747474] ${icon ? "ps-10" : "ps-3"}`}>
                            Loading tasks...
                        </p>
                    ) : value && value !== 0 ? (
                        <div className="flex items-center gap-2 border border-gray-300 rounded-md px-2 py-1 ms-10 w-fit">
                            <p className="m-0 text-[13px] font-medium text-gray-700 capitalize">
                                {selectedLabel}
                            </p>

                            {!disabled && (
                                <X
                                    size={14}
                                    className="cursor-pointer text-[#747474] w-4 h-4"
                                    onClick={handleClear}
                                />
                            )}
                        </div>
                    ) : (
                        <p className={`m-0 text-[13px] 2xl:text-[16px] text-[#747474] ${icon ? "ps-10" : "ps-3"}`}>
                            {label}
                        </p>
                    )}

                    {/* Right Icon */}
                    <ChevronDown
                        className={`absolute right-3 transition-transform duration-200 pointer-events-none 
                        ${isOpen ? "rotate-180" : ""}`}
                        size={18}
                        color="#777"
                    />
                </div>

                {/* Dropdown menu */}
                {/* {isOpen && (
                    <ul className="absolute left-1/2 -translate-x-1/2 z-10 w-[90%] mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-36 overflow-y-auto p-0">
                        {filteredOptions.length > 0 ? (
                            filteredOptions.map((opt) => (
                                <li
                                    key={opt.value}
                                    onClick={() => {
                                        onChange(opt.value);
                                        setIsOpen(false);
                                    }}
                                    className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-[#333]"
                                >
                                    {opt.label}
                                </li>
                            ))
                        ) : (
                            <li className="px-3 py-2 text-gray-500">No options</li>
                        )}
                    </ul>
                )} */}

                {isOpen && !disabled && (
                    <div className="absolute left-1/2 -translate-x-1/2 z-10 w-[90%] mt-1 bg-white border border-gray-300 rounded-lg shadow-lg overflow-hidden">

                        {/* Search box */}
                        <div className="px-3 py-2 border-b border-gray-200">
                            <div className="flex items-center gap-2">
                                <svg
                                    className="w-4 h-4 text-gray-400"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.5 4.5a7.5 7.5 0 0012.15 12.15z"
                                    />
                                </svg>

                                <input
                                    ref={inputRef}
                                    className={`w-full bg-transparent outline-none border-none text-[13px] 2xl:text-[16px] text-[#747474] !py-0`}
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    style={{
                                        border: 'none',
                                        background: 'transparent',
                                        outline: 'none',
                                        boxShadow: 'none',
                                        color: '#747474',
                                    }}
                                />
                            </div>
                        </div>

                        {/* Options */}
                        <ul className="max-h-24 overflow-y-auto ps-0">
                            {filteredOptions.length > 0 ? (
                                filteredOptions.map((opt) => {
                                    return <li
                                        key={opt.value}
                                        onClick={() => {
                                            onChange(opt.value);
                                            setIsOpen(false);
                                            setSearchTerm("");
                                        }}
                                        className="px-4 py-1.5 cursor-pointer hover:bg-[#F9F6FF]"
                                    >
                                        <p className="text-xs text-gray-500 mb-0.5">
                                            #{opt.friendlyId} {opt.participant}
                                        </p>
                                        <p className="text-sm font-semibold text-gray-900 m-0">
                                            {opt.label}
                                        </p>
                                    </li>;
                                })
                            ) : (
                                <li className="px-4 py-3 text-sm text-gray-500">
                                    No results found
                                </li>
                            )}
                        </ul>
                    </div>
                )}

            </div>

            {error && <p className="text-red-500 text-sm ps-10">{error}</p>}
        </div>
    );
};

export default TaskDropdown;
